/*
 *
 * DatasetEdit reducer
 *
 */
import produce from 'immer';
import { GET_DATASET_FAILURE, GET_DATASET_REQUEST, GET_DATASET_SUCCESS, UPDATE_DATASET_FAILURE, UPDATE_DATASET_REQUEST, UPDATE_DATASET_SUCCESS, UPDATE_DATASET_COLUMN_ORDER_REQUEST, UPDATE_DATASET_COLUMN_ORDER_SUCCESS, UPDATE_DATASET_COLUMN_ORDER_FAILURE, } from './constants';
export var initialState = {
    dataset: {},
    meta: {},
    loading: false,
    saving: false,
    loading_error: false,
    saving_error: false,
    patchwork: {},
    patchwork_loading: false,
    patchwork_error: false,
    update_order_loading: false,
    update_order_error: false,
};
function datasetReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case GET_DATASET_REQUEST:
                state.loading = true;
                state.loading_error = false;
                break;
            case GET_DATASET_SUCCESS:
                state.dataset = action.dataset;
                state.meta = action.meta;
                state.loading = false;
                state.loading_error = false;
                break;
            case GET_DATASET_FAILURE:
                state.loading = false;
                state.loading_error = true;
                break;
            case UPDATE_DATASET_REQUEST:
                state.saving = true;
                state.saving_error = false;
                break;
            case UPDATE_DATASET_SUCCESS:
                state.dataset = action.dataset;
                state.meta = action.meta;
                state.saving = false;
                state.saving_error = false;
                break;
            case UPDATE_DATASET_FAILURE:
                state.saving = false;
                state.saving_error = true;
                break;
            case UPDATE_DATASET_COLUMN_ORDER_REQUEST:
                state.update_order_loading = true;
                state.update_order_error = false;
                break;
            case UPDATE_DATASET_COLUMN_ORDER_SUCCESS:
                state.update_order_loading = false;
                state.update_order_error = false;
                break;
            case UPDATE_DATASET_COLUMN_ORDER_FAILURE:
                state.update_order_loading = false;
                state.update_order_error = true;
                break;
            default:
                break;
        }
    });
}
export default datasetReducer;
